import { useTranslation } from '@cobliteam/i18n';
import Typography from '@cobliteam/ui/components/Typography';
import Icon from '@cobliteam/ui/icons';
import { toolNameMap } from '../../types';
import { type ChatMessagePart, getToolLoadingKey, getToolState, isToolPart } from './utils';

const ToolLoadingList = ({ parts }: { parts: ChatMessagePart[] }) => {
  const { t } = useTranslation('ai');
  const activeToolParts = parts.filter((part) => {
    if (!isToolPart(part)) return false;
    const state = getToolState(part);
    return state !== 'output-available' && state !== 'output-error';
  });

  if (activeToolParts.length === 0) return null;

  return (
    <div className='my-3 flex flex-col gap-1 rounded-lg border border-gray-4 bg-white/60 px-3 py-2 shadow-sm'>
      {activeToolParts.map((part, index) => {
        const toolName = toolNameMap[part.type] || t('tool_loading_fallback');
        return (
          <div key={getToolLoadingKey(part, index)} className='flex min-h-7 items-center gap-2 text-gray-10'>
            <Icon name='loader-circle' size='sm' className='size-4 shrink-0 animate-spin text-primary-9' />
            <Typography variant='text-sm' className='min-w-0 truncate text-gray-10'>
              {toolName}
            </Typography>
          </div>
        );
      })}
    </div>
  );
};

export default ToolLoadingList;
